import axios from "axios";
import React, { useEffect, useState } from "react";
import { UserConsumer } from "../../UserContext";
import Header from "../../components/Header";
import { Table } from "../../components/CustomPaginations";
import { dateCol, tableStyle } from "../../components/TableStyle";
import FilterationBar from "./FilterationBar";

import ReactTooltip from "react-tooltip";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { CalendarHolidays_API } from "./CalendarHolidays_API";

function CalendarHolidays() {
	let token = null;
	const defaultSorted = [
		{
			dataField: "startDate",
			order: "desc",
		},
	];
	const getColumns = [
		{
			dataField: "startDate",
			text: "Start Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "endDate",
			text: "End Date",
			sort: true,
			formatter: dateCol,
		},
		{
			dataField: "duration",
			text: "Duration",
			sort: true,
		},
		{
			dataField: "description",
			text: "Description",
			sort: true,
			formatter: (value) => {
				return (
					<span data-tip={value}>
					{value.length > 50 ? value.substring(0, 50) + "..." : value}
					<ReactTooltip place="top" type="dark" effect="solid" />
				</span>
				);
			},
		},
	];
	const date = new Date();
	const currentYear = date.getFullYear();
	const [selectedYear, setSelectedYear] = useState({
		value: currentYear,
		label: currentYear,
	});
	const [isLoading, setIsLoading] = useState(true);
	const [yearsList, setYearsList] = useState([]);
	const [pageNum, setPageNum] = useState(1);
	const [calendarHolidaysData, setCalendarHolidaysData] = useState([]);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);
	const [pagerData, setPagerData] = useState([]);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(20);
	useEffect(() => {
		//To auto start from company date(2006) till current year
		let startYear = 2006;
		const list = [];
		do {
			list.unshift({ value: startYear, label: startYear.toString() });
			startYear++;
		} while (startYear != currentYear + 1);
		setYearsList(list);

		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${CalendarHolidays_API.GetCalendarHolidaysbyPagination}?Year=${currentYear}&PageNumber=${pageNum}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{ headers: headers }
			)
			.then(({ status, data, headers }) => {
				if (status === 200) {
					setIsLoading(false);
					setCalendarHolidaysData(data.calendarHolidays);
					setPagerData(JSON.parse(headers["x-pagination"]));
				}
			});
	}, []);

	const onYearChange = (year) => {
		//call api on year change
		setIsLoading(true);
		setSelectedYear(year);
		axios
			.get(
				`${CalendarHolidays_API.GetCalendarHolidaysbyPagination}?Year=${year.value}&PageNumber=${pageNum}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ status, data, headers }) => {
				if (status === 200) {
					setIsLoading(false);
					setCalendarHolidaysData(data.calendarHolidays);
					setPagerData(JSON.parse(headers["x-pagination"]));
				}
			});
	};

	const receiveData = (PageSize) => {
		//call api on table page size change
		setIsLoading(true);
		axios
			.get(
				`${CalendarHolidays_API.GetCalendarHolidaysbyPagination}?Year=${
					selectedYear.value
				}&PageNumber=${1}&PageSize=${PageSize}&SortBy=${
					sortBy.dataField
				}_${sortBy.order}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setPageNum(1);
					setIsLoading(false);
					setNumberOfItemsPerPage(PageSize);
					setCalendarHolidaysData(res.data.calendarHolidays);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		//call api on table sorting and pagination

		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		if (type === "sort") {
			apiURL = `${CalendarHolidays_API.GetCalendarHolidaysbyPagination}?Year=${selectedYear.value}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`;
			setSortBy({ dataField: sortField, order: sortOrder });
			getData = true;
		} else if (type === "pagination") {
			apiURL = `${CalendarHolidays_API.GetCalendarHolidaysbyPagination}?Year=${selectedYear.value}&PageNumber=${page}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`;
			getData = true;
		}
		if (getData) {
			axios
				.get(apiURL, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then((res) => {
					if (res.status === 200) {
						setPageNum(page);
						setIsLoading(false);
						setCalendarHolidaysData(res.data.calendarHolidays);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
					}
				});
		}
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Calendar Holidays"
								headerBorder={true}
							/>
							<FilterationBar
								years={yearsList}
								selectedYear={selectedYear}
								onYearChange={(year) => onYearChange(year)}
							/>

							{/*Table with pagination*/}
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
											keyField={"token"}
											columns={getColumns}
											items={calendarHolidaysData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={true}
											tableLoader={isLoading}
											pagerData={pagerData}
											SearchBar={() => {
												return null;
											}}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
										/>
									);
								}}
							</PaginationProvider>
						</div>
						<ReactTooltip id="description" place="top" type="dark" effect="solid" />
				
					</>
				);
			}}
		</UserConsumer>
	);
}

export default CalendarHolidays;
